import React from 'react';
import { Link } from 'react-router-dom';

export const Landing = () => {
  return (
    <div className='landing' >
      <h1>Bienvenidos</h1>
      <Link to={'/home'} >
        <button>
          <span>Ingresar</span>
        </button>
      </Link>
    </div>
  )
}
